module.exports = __webpack_public_path__ + "img/HM1999.73060b8d.png";